import type { App } from 'vue';
import util from '@utils/index';
import VConsole from 'vconsole';
import UUID from 'uuidjs';
import { getEnv } from '@utils/env';
import type { configType } from './main.type';

export default {
  install(app: App<Element>, config: configType) {
    app.config.globalProperties.util = util;
    // 当前项目中的错误信息，会在页面中展示的，当为空时，就不会展示
    app.config.globalProperties.$errorMessage = '';
    const $env = getEnv();
    app.config.globalProperties.$env = $env;
    // 是否需要去绑定小程序，默认不需要
    app.config.globalProperties.$isNeedToBindMobile = false;
    app.config.globalProperties.$mobile = '';
    app.config.globalProperties.$isThirdPartyApp = false;

    const href = window.location.href || '';
    if (href.indexOf('https://qw-scrm-qa.dustess.net/') > -1) {
      const vconsole = new VConsole();
      vconsole.showSwitch();
    }
    // 上报对象
    app.config.globalProperties.mkWebReportSDK = null;

    // 生成cookeid
    let cookieId = window.localStorage.getItem('cookieId');
    if (!cookieId) {
      cookieId = UUID.generate();
      window.localStorage.setItem('cookieId', cookieId);
    }
    app.config.globalProperties.$cookieId = cookieId;

    // 初始化页面
    const toInitVue = async () => {
      config.newVue();
    };

    toInitVue();
    // 强制禁止用户修改微信客户端的字体大小
    const handleFontSize = () => {
      window.WeixinJSBridge.invoke('setFontSizeCallBack', { fontSize: 0 });
      window.WeixinJSBridge.on('menu:setfont', () => {
        window.WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 });
      });
    };
    if (typeof window.WeixinJSBridge === 'object' && typeof window.WeixinJSBridge.invoke === 'function') {
      handleFontSize();
    }
    else if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', handleFontSize, false);
    }
    else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', handleFontSize);
      document.attachEvent('onWeixinJSBridgeReady', handleFontSize);
    }
  }
};
